import Button from "../components/ui/Button";

export default function NotFoundPage() {
  return (
    <section className="section">
      <div className="container" style={{ textAlign: "center", padding: "160px 0 120px" }}>
        <p className="eyebrow">Error 404</p>
        <h1 className="section-title">Esta página no existe</h1>
        <p className="section-lead" style={{ margin: "0 auto 32px" }}>
          Es posible que el enlace haya cambiado. Vuelva al inicio o cotice su flete con nosotros.
        </p>
        <Button href="/" variant="primary" arrow>
          Ir al inicio
        </Button>
      </div>
    </section>
  );
}
